// extracted by mini-css-extract-plugin
export default {"departments-listing":"DepartmentsList_departments-listing__G7VPQ"};